/**
 * Scroll-driven Rive: scroll progress scrubs the `idle` animation timeline.
 */

import { Rive, Layout, Fit, Alignment } from '@rive-app/canvas';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * @param {import('@rive-app/canvas').Rive} r
 */
function wireResize(r) {
	const onResize = () => {
		r.resizeDrawingSurfaceToCanvas();
	};
	window.addEventListener('resize', onResize);
	return () => window.removeEventListener('resize', onResize);
}

/**
 * @returns {void | (() => void)}
 */
export function initRiveScrollSection() {
	const section = document.querySelector('.rive-scroll-section');
	const canvas = document.getElementById('rive-canvas');
	const spacer = document.querySelector('.rive-scroll-section .scroll-spacer');

	if (!section || !canvas || !spacer) {
		return undefined;
	}

	const rivSrc = section.getAttribute('data-rive-src');
	if (!rivSrc) {
		console.warn('[RiveScroll] Missing data-rive-src on .rive-scroll-section');
		return undefined;
	}

	gsap.registerPlugin(ScrollTrigger);

	let removeResize = () => { };
	/** @type {import('gsap/ScrollTrigger').ScrollTrigger | null} */
	let st = null;

	const rive = new Rive({
		src: rivSrc,
		canvas,
		autoplay: false,
		animations: 'idle',
		layout: new Layout({
			fit: Fit.Cover,
			alignment: Alignment.TopCenter,
		}),
		onLoad: () => {
			rive.resizeDrawingSurfaceToCanvas();
			removeResize = wireResize(rive);
			console.log('[RiveScroll] Rive instance durations:', rive.durations);
			const duration = rive.durations[0];
			if (duration == null || duration <= 0) {
				console.warn('[RiveScroll] Missing or zero duration; check animation name is "idle" in the .riv file');
				return;
			}

			st = ScrollTrigger.create({
				trigger: spacer,
				start: 'top top',
				end: 'bottom bottom',
				scrub: 1,
				onUpdate(self) {
					rive.scrub('idle', self.progress * duration);
				},
			});

			ScrollTrigger.refresh();
			rive.scrub('idle', st.progress * duration);
		},
	});

	return () => {
		st?.kill();
		removeResize();
		rive.cleanup();
	};
}
